export { default } from './PrintPage'
